import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import SmartEnglishLanding from './pages/start';
import Login from './pages/login';
import Register from './pages/register';
import StudentTestDashboard from './pages/student_dashboard';
import SBAULISSystem from './pages/test';
import TeacherCMS from './pages/teacher_cms';
import TestStartPage from './pages/test_cms';
import AddQuestionComponent from './components/add_question';
import AITeacherChatbot from './components/Chatbot';
import QuestionList from './pages/questions/QuestionList';
import QuestionForm from './pages/questions/QuestionForm';

// ✅ Import Toastify
import { ToastContainer, Bounce } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './styles/toastify-custom.css';


// Component để điều khiển việc hiển thị chatbot
function ChatbotWrapper() {
  const location = useLocation();

  // Danh sách các routes không hiển thị chatbot
  const hideChatbotRoutes = [
    '/student/test/', // Bao gồm cả dynamic routes như /student/test/1, /student/test/2, etc.
  ];

  // Kiểm tra nếu route hiện tại nằm trong danh sách cần ẩn chatbot
  const shouldHideChatbot = hideChatbotRoutes.some(route =>
    location.pathname.startsWith(route) || location.pathname === '/student/test'
  );

  // Chỉ hiển thị chatbot nếu không phải là route cần ẩn
  if (shouldHideChatbot) {
    return null;
  }

  return <AITeacherChatbot />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SmartEnglishLanding />} />
        <Route path="/student/login" element={<Login />} />
        <Route path="/teacher/login" element={<Login />} />
        <Route path="/student/register" element={<Register />} />
        {/* Dashboard route */}
        <Route path="/student/dashboard" element={<StudentTestDashboard />} />

        {/* Dynamic test route with testId parameter */}
        <Route path="/student/test/:testId" element={<SBAULISSystem />} />

        {/* Legacy route for backward compatibility */}
        <Route path="/student/test" element={<Navigate to="/student/dashboard" replace />} />

        {/* Default route redirects to dashboard */}
        <Route path="/" element={<Navigate to="/student/dashboard" replace />} />

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/student/dashboard" replace />} />
        <Route path="/student/test" element={<SBAULISSystem />} />
        {/* Teacher CMS với wildcard */}
        <Route path="/teacher/cms/*" element={<TeacherCMS />} />

        <Route path="/test/cms" element={<TestStartPage />} />
        <Route path="/test/add-question/:testId" element={<AddQuestionComponent />} />

        {/* ✅ Quản lý Question */}
        <Route path="/cms/questions" element={<QuestionList />} />
        <Route path="/cms/questions/new" element={<QuestionForm />} />
        <Route path="/cms/questions/:id/edit" element={<QuestionForm />} />
      </Routes>

      {/* Chatbot với điều kiện hiển thị */}
      <ChatbotWrapper />

      {/* ✅ Toastify container hiển thị toàn ứng dụng */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
        transition={Bounce} // ✅ đúng cú pháp
      />
    </Router>
  );
}

export default App;
